import { render } from "./MusicText.vue?vue&type=template&id=b85b0dae&scoped=true"
import script from "./MusicText.vue?vue&type=script&lang=js"
export * from "./MusicText.vue?vue&type=script&lang=js"

import "./MusicText.vue?vue&type=style&index=0&id=b85b0dae&scoped=true&lang=css"

import exportComponent from "/Users/gabrielvoirol/git_projects/df_wpheadless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b85b0dae"]])

export default __exports__